import { useNavigate, useParams } from 'react-router-dom';
import { Card } from 'antd';
import { useTaskDetail } from '../../features/tasks/api';
import { PageHeader } from '../../components/PageHeader';
import { RecordError } from '../../components/states';
import { TaskDetailPanel } from './TaskDetailPanel';
import './tasks.css';

/** A task's own address (/tasks/:id): what "Copy task link" shares. */
export function TaskPage() {
  const { id = '' } = useParams();
  const navigate = useNavigate();
  const detail = useTaskDetail(id);
  if (detail.isError) return <div className="page"><RecordError error={detail.error} what="task" backTo="/tasks" backLabel="Back to tasks" onRetry={detail.refetch} /></div>;
  return (
    <div className="page page-narrow" style={{ maxWidth: 900 }}>
      <PageHeader
        title={detail.data ? `Task #${detail.data.number}` : 'Task'}
        docTitle={detail.data?.title}
        breadcrumb={[{ title: 'Tasks', to: '/tasks' }, { title: detail.data ? `#${detail.data.number}` : '…' }]}
      />
      <Card styles={{ body: { padding: 0 } }}>
        <TaskDetailPanel taskId={id} onOpen={(next) => navigate(`/tasks/${next}`)} onClose={undefined} />
      </Card>
    </div>
  );
}
